module.exports = __webpack_public_path__ + "img/alumni-information-active.de32d1a1.svg";